module.exports = __webpack_public_path__ + "stratumblue_mobile_banner_es.jpg?808717dd240eb4d0b8ebcde7fc4f1360";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/stratumblue_mobile_banner_es.jpg
// module id = 763
// module chunks = 2